import React, { useEffect, useState } from "react";
import Layout, { PageHero } from "../components/site/Layout";
import client from "../lib/api";

export default function LegalPage({ slug }) {
  const [page, setPage] = useState(undefined); // undefined = loading, null = not available

  useEffect(() => {
    let active = true;
    setPage(undefined);
    // Check the published list first so draft/unknown slugs don't fire a 404 request.
    client.get("/public/legal")
      .then(({ data }) => {
        if (!active) return;
        const found = (data || []).some((p) => p.slug === slug);
        if (!found) { setPage(null); return; }
        return client.get(`/public/legal/${slug}`).then(({ data: d }) => { if (active) setPage(d); });
      })
      .catch(() => { if (active) setPage(null); });
    return () => { active = false; };
  }, [slug]);

  useEffect(() => {
    if (page && page.metaTitle) {
      const prev = document.title;
      document.title = page.metaTitle;
      return () => { document.title = prev; };
    }
  }, [page]);

  const title = page ? page.title : (page === null ? "Page Not Available" : "Loading…");

  return (
    <Layout>
      <PageHero eyebrow="Legal" title={title} />
      <section className="mx-auto max-w-3xl px-5 py-16 lg:px-10" data-testid={`legal-page-${slug}`}>
        {page === undefined && <p className="text-ink-muted">Loading…</p>}
        {page === null && (
          <p className="text-base leading-relaxed text-ink-muted">
            This page is not currently available. Please check back later.
          </p>
        )}
        {page && (
          <div className="legal-content space-y-4 text-base leading-relaxed text-ink-muted"
            dangerouslySetInnerHTML={{ __html: page.content || "" }} />
        )}
      </section>
      <style>{`
        .legal-content h2{font-family:'Cormorant Garamond',Georgia,serif;color:#58181F;font-size:1.5rem;font-weight:500;margin:2rem 0 .75rem;}
        .legal-content h3{color:#58181F;font-size:1.15rem;font-weight:600;margin:1.25rem 0 .5rem;}
        .legal-content p{margin:.75rem 0;}
        .legal-content ul{list-style:disc;padding-left:1.5rem;margin:.75rem 0;}
        .legal-content ol{list-style:decimal;padding-left:1.5rem;margin:.75rem 0;}
        .legal-content a{color:#58181F;text-decoration:underline;}
        .legal-content a:hover{color:#8C714B;}
        .legal-content table{border-collapse:collapse;width:100%;margin:1rem 0;}
        .legal-content th,.legal-content td{border:1px solid rgba(184,151,104,.4);padding:.6rem .85rem;text-align:left;}
        .legal-content th{background:#FAF8F5;color:#58181F;}
      `}</style>
    </Layout>
  );
}
